module.exports = __webpack_public_path__ + "img/4_122.362257dd.png";